import { z as e } from "zod";
import { p as i, v as c } from "./v1-Bs45k34H.js";
import { p as o, v as t } from "./v2-BJR4OMiI.js";
import { p as s, l as n } from "./v3-D9Cad3q4.js";
const p = e.discriminatedUnion("version", [
  e.object({
    version: e.literal(1),
    priceCheck: i,
    priceCheckExperience: e.string().nullish()
  }),
  e.object({
    version: e.literal(2),
    priceCheck: o,
    priceCheckExperience: e.string().nullish()
  }),
  e.object({
    version: e.literal(3),
    priceCheck: s,
    priceCheckExperience: e.string().nullish()
  })
]), l = e.preprocess((r) => typeof r == "object" && r !== null && !("version" in r) ? { ...r, version: 1 } : r, p), u = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  latest: n,
  v1: c,
  v2: t,
  versionedResult: l
}, Symbol.toStringTag, { value: "Module" }));
export {
  u as i,
  l as v
};
